import React, { useState } from "react";

import NavBar from "../../components/NavBar";
import MenuBar from "../../components/MenuBar";
import Notifications from "../../components/NotificationsModal";
import ProfileDropdown from "../../components/ProfileDropdown";
import SearchPage from "../SearchPage";

function MainLayout({ children }) {

  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const handleNotificationsClick = async() => {
    setShowNotifications((prevShowDropdown) => !prevShowDropdown);
  };

  const handleProfileClick = async() => {
    setShowProfileDropdown((prevShowDropdown) => !prevShowDropdown);
  };

  return (
    <div>
      <MenuBar handleNotificationsClick={handleNotificationsClick} 
        handleProfileClick={handleProfileClick} 
      />
      {showNotifications && <Notifications onClose={() => setShowNotifications(false)}/>}
      {showProfileDropdown && <ProfileDropdown onClose={() => setShowProfileDropdown(false)}/>}
      <NavBar />
      {children.type.name === 'SearchPage' ? (
          <SearchPage />
        ) : (
          children
        )}
    </div>
  );
}

export default MainLayout;